import { green, red, yellow } from '@mui/material/colors';
import { OrderConversionChartStatuses } from 'types/embedded/orderConversion';

export const orderStatusesColorSchema = {
  [OrderConversionChartStatuses.Success]: green[300],
  [OrderConversionChartStatuses.Failure]: red[400],
  [OrderConversionChartStatuses.Pending]: yellow[600],
};
